import React from 'react';
import {connect} from "react-redux";
import Renderers from "../../helpers/Renderers";
import {bindActionCreators} from 'redux';
import * as tabActions from "../../redux/modules/tabs";
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import Client from "../../helpers/ApiClient";
import {AlertWindow} from "../../reactis/reactis-modal";

class DriverSubform extends React.Component {

	static contextTypes= {
		router: React.PropTypes.object,
    store: React.PropTypes.object,
	};

	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	handleOpen(e, row) {
		e.preventDefault();
		this.props.actions.openTabForm('driver', row.surname + ' ' + row.name, {id: row.driver});
	}

  handleMoveGroups(e, row) {
    e.preventDefault();
    const data = {
      id: row.driver,
      ext_groups1: row.ex_groups1,
      ext_groups2: row.ex_groups2,
      ext_groups_z_text: row.ex_groups_z_text,
    };
    const api = new Client();
    api.call('driver.setExtGroups', data, {progress: true}).then((result) => {
      if (result) {
        const msg = <div>Rozšíření oprávnění bylo přeneseno do karty řidiče.<br/><br/>Výsledné oprávnění řidiče je <b>{result.groups}</b></div>
        const alert = new AlertWindow('Oprávnění', msg);
        alert.show(this.context.store.dispatch, () => {});
      }
    });
  }

	render() {
		const values = this.props.state.get('values').toJS();
    let hasExtGroups = false;
    Object.keys(values.ex_groups1).forEach((key) => {
      if (values.ex_groups1[key]) {
        hasExtGroups = true;
      }
    });
    Object.keys(values.ex_groups2).forEach((key) => {
      if (values.ex_groups2[key]) {
        hasExtGroups = true;
      }
    });
    let zActive = values.groups1['z'] || values.groups2['z'];
    let ex_zActive = values.ex_groups1['z'] || values.ex_groups2['z'];

		return (
      <tr className={this.state.overRemove ? 'subformOverRemove' : null}>
        <td className="name" style={{verticalAlign: 'top'}}>{values.surname}</td>
        <td className="name"  style={{verticalAlign: 'top'}}>{values.name}</td>
        <td className="name"  style={{verticalAlign: 'top'}}>{Renderers.Date(values.born)}</td>
        <td className="name" style={{padding:0, verticalAlign: 'top'}}>
          <table className="tablegroups">
            <tr>
              <td>I.</td>
              <td><FormField name="groups1"/></td>
            </tr>
            <tr>
              <td>II.</td>
              <td><FormField name="groups2"/></td>
            </tr>
            {zActive && <tr>
              <th></th>
              <td>
                <div style={{marginTop: 5}}>
                  <FormField name="groups_z_text"/>
                </div>
              </td>
            </tr>}
          </table>
        </td>
        <td className="name" style={{padding: 0, verticalAlign: 'top'}}>
          <table className="tablegroups">
            <tr>
              <td>I.</td>
              <td><FormField name="ex_groups1"/></td>
            </tr>
            <tr>
              <td>II.</td>
              <td><FormField name="ex_groups2"/></td>
            </tr>
            {ex_zActive && <tr>
              <th></th>
              <td>
                  <div style={{marginTop: 5}}>
                    <FormField name="ex_groups_z_text"/>
                  </div>
              </td>
            </tr>}
          </table>
        </td>
        <td style={{width: 160, verticalAlign: "top"}}>
          <a onClick={(e) => this.handleOpen(e, values)}><span className="fa fa-pencil"></span></a><br/>
          {hasExtGroups &&
            <div style={{marginTop: 10}}>
              <a title="Přenést rozšíření do karty řidiče" onClick={(e) => this.handleMoveGroups(e, values)}>přenést rozšíření k řidiči</a>
            </div>
          }
        </td>
        <td ><i title="Odstranit"
               onClick={this.props.onRemove}
               onMouseOver={() => this.handleMouseOver()}
               onMouseOut={() => this.handleMouseOut()}
               className="icon-cross removesubform"/>
        </td>
      </tr>
    )
  }
}

export default connect(null, (dispatch) => {
  return {actions: bindActionCreators(tabActions, dispatch)};
})(DriverSubform);


// WEBPACK FOOTER //
// ./src/containers/Training/DriverSubform.js